/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MinusCircleIcon16Light } from './MinusCircleIcon16Light';
import { MinusCircleIcon16Regular } from './MinusCircleIcon16Regular';
import { MinusCircleIcon16Solid } from './MinusCircleIcon16Solid';
import { MinusCircleIcon20Light } from './MinusCircleIcon20Light';
import { MinusCircleIcon20Regular } from './MinusCircleIcon20Regular';
import { MinusCircleIcon20Solid } from './MinusCircleIcon20Solid';
import { MinusCircleIcon24Regular } from './MinusCircleIcon24Regular';
import { MinusCircleIcon24Solid } from './MinusCircleIcon24Solid';
import { MinusCircleIcon32Regular } from './MinusCircleIcon32Regular';
import { MinusCircleIcon64Regular } from './MinusCircleIcon64Regular';
var sizes = {
    16: {
        light: MinusCircleIcon16Light,
        regular: MinusCircleIcon16Regular,
        solid: MinusCircleIcon16Solid,
    },
    20: {
        light: MinusCircleIcon20Light,
        regular: MinusCircleIcon20Regular,
        solid: MinusCircleIcon20Solid,
    },
    24: {
        regular: MinusCircleIcon24Regular,
        solid: MinusCircleIcon24Solid,
    },
    32: {
        regular: MinusCircleIcon32Regular,
    },
    64: {
        regular: MinusCircleIcon64Regular,
    },
};
export var MinusCircleIcon = forwardRef('MinusCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
